import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function VerifyCallbackPage() {
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Finishing verification…");
  const [username, setUsername] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const oauthError = params.get("error");

    if (oauthError) {
      setStatus("error");
      setMessage(
        params.get("error_description") ||
          "Discord denied the authorization request.",
      );
      return;
    }

    if (!code || !state) {
      setStatus("error");
      setMessage("Missing verification details. Open the verify button in Discord and try again.");
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/verify/finish`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code, state }),
        });
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (!res.ok) {
          setStatus("error");
          setMessage(data.error || "Verification failed.");
          return;
        }
        setStatus("ok");
        setUsername(data.globalName || data.username || "");
        setMessage("You are verified. You can return to Discord.");
      } catch {
        if (!cancelled) {
          setStatus("error");
          setMessage("Could not reach the verification service. Try again shortly.");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="legal-page" style={{ maxWidth: 520, margin: "80px auto" }}>
      <h1>
        {status === "ok"
          ? "✦ Verified"
          : status === "error"
            ? "Verification failed"
            : "☾ Verifying…"}
      </h1>
      <p>{message}</p>
      {username ? (
        <p style={{ opacity: 0.75 }}>
          Signed in as <strong>{username}</strong>
        </p>
      ) : null}
      {status !== "loading" ? (
        <p style={{ marginTop: 24 }}>
          <Link to="/">Back to Nocturne</Link>
        </p>
      ) : null}
    </div>
  );
}
